"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../../core/theme");
exports.default = {
    progressPlayed: {
        backgroundColor: function (data) { return data.progressColor; },
    },
    progressSeekTo: {
        backgroundColor: function (data) {
            return theme_1.transperentizeColor(data.progressColor, 0.5);
        },
    },
    progressBackground: {
        backgroundColor: function (data) {
            return theme_1.transperentizeColor(data.progressColor, 0.25);
        },
    },
    progressSeekBtn: {
        backgroundColor: function (data) { return data.progressColor; },
    },
    progressSyncBtn: {
        borderColor: function (data) { return data.progressColor; },
    },
};
//# sourceMappingURL=progress.theme.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/controls/progress/progress.theme.js
// module id = 173
// module chunks = 0